<div *ngIf="!isError">
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <div>
        <div class="flex-container-center small-padding small-margin">
            <div class="item-image-holder flex-child">
                <img src="{{comboHolder.Combo.Picture}}" class="item-image" onerror="this.src='assets/img/placeholder.png'">
            </div>
            <div class="description-text">{{comboHolder.Combo.Description}}</div>
        </div>
        <div class="horizontal-center">
            <div class="label center-text">{{'Pages.Combo.Quantity' | translate}}</div>
            <div class="horizontal-center">
                <div class="flex-container-center">
                    <button mat-icon-button color="accent" (click)="countTap(-1)">
                        <mat-icon>remove</mat-icon>
                    </button>
                    <div mat-ripple class="cell-toggle" (click)="countTap(0)"><p>{{comboHolder.Combo.ComboCount}}</p></div>
                    <button mat-icon-button color="accent" (click)="countTap(1)">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <div class="floating-text bold">{{'Pages.Combo.ComboItensTitle' | translate}}</div>
            <mat-divider></mat-divider>
        </div>
        <div>
            <div *ngFor="let itemGroup of comboHolder.Combo.ItemGroupsList">
                <div class="disable-select" (click)="groupTap(itemGroup)">
                    <div class="flex-container-center list-cell" mat-ripple>
                        <div class="small-padding">
                            <div class="list-item-group-label">{{itemGroup.ShowName}}</div>
                            <div class="list-item-group-detail summary-text">{{itemGroup.Summary}}</div>
                        </div>
                        <span class="filler"></span>
                        <button *ngIf="itemGroup.IsOptionalOkay === false" mat-icon-button color="accent">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                </div>
            </div>
        </div>
        <mat-toolbar class="bar-filler">
            <mat-toolbar-row>
                <p></p>
            </mat-toolbar-row>
            <mat-toolbar-row>
                <p></p>
            </mat-toolbar-row>
            <mat-toolbar-row *ngIf="isRedirect === true">
                <p></p>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <mat-toolbar color="primary" class="top-bar">
        <button *ngIf="isRedirect !== true" mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <button *ngIf="isRedirect === true" mat-icon-button (click)="goHome()">
            <mat-icon>home</mat-icon>
        </button>
        <div>{{comboHolder.Name}}</div>
        <div class="filler"></div>
        <button mat-icon-button [cdkCopyToClipboard]="comboLink" (click)="copyLink()">
            <mat-icon>link</mat-icon>
        </button>
    </mat-toolbar>
    <mat-toolbar matRipple #bottomBar id="bottomBar" [matRippleDisabled]="true" [matRippleColor]="rippleColor" color="primary" class="bottom-bar">
        <mat-toolbar-row>
            <div class="big-price-text">{{currentPriceString}}</div>
        </mat-toolbar-row>
        <mat-toolbar-row>
            <button mat-flat-button *ngIf="isClosed === false && status === 'new'" color="accent" disabled="{{!canSave}}" (click)="save()" class="fill-parent-width">{{'Pages.Combo.Add' | translate}}</button>
            <button mat-flat-button *ngIf="isClosed === false && status === 'edit'" color="accent" disabled="{{!canSave}}" (click)="save()" class="fill-parent-width">{{'Pages.Combo.Save' | translate}}</button>
            <button mat-flat-button *ngIf="isClosed === true" color="warn" (click)="showWorkTime()" class="fill-parent-width">{{'Pages.Combo.Closed' | translate}}</button>
        </mat-toolbar-row>
        <mat-toolbar-row *ngIf="isRedirect === true">
            <button mat-button color="accent" (click)="goHome()" class="fill-parent-width">{{'Pages.Combo.Home' | translate}}</button>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<div *ngIf="isError" class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Pages.Combo.Error.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{'Pages.Combo.Error.Message' | translate}}</p>
          </mat-card-content>
        <mat-card-actions *ngIf="isRedirect === true">
            <button mat-raised-button color="accent" class="fill-parent-width" (click)="goHome()">{{'Pages.Combo.Error.Button' | translate}}</button>
        </mat-card-actions>
    </mat-card>
</div>
